<template>

  <!-- spinner -->
  <md-button 
    class="md-icon-button md-primary md-simple"
    v-if="loading" 
    >
    <md-progress-spinner 
      :md-diameter="17" 
      :md-stroke="2" 
      md-mode="indeterminate" 
      class="no-fade-out"
      />
  </md-button>

  <!-- icon -->
  <md-button 
    class="md-icon-button md-primary md-simple" 
    @click="$emit('click', $event)" 
    :disabled="disabled"
    v-else >
    <md-icon>
      <slot />
    </md-icon>
    <md-tooltip :md-direction="tooltipDirection" v-if="tooltip">{{ tooltip }}</md-tooltip>
  </md-button>

</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    // icon: {
    //   type: String,
    //   default: ''
    // },
    tooltip: {
      type: String,
      default: ''
    },
    tooltipDirection: {
      type: String,
      default: 'top'
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  }
};
</script>
<style></style>
